import angular from 'angular';
import _ from 'lodash-es';
import APIV5 from '~/models/api';
import rowDetailsModal from '~/components/ktable/modals/row-details/row-details-modal.component';
import { rowNumberColumnDefinition } from '../ktable/columnFactory';
import { stringFormatter } from '../kdatatable/formatters';
// import Defaults from '~/scripts/constants/defaults';

/* globals Knitiv */

const packetSize = 25;

/**
 * @implements {angular.IController}
 */
export default class KElseController {
	/* @ngInject */
	/**
	 * @param {angular.ui.bootstrap.IModalService} $uibModal
	 * @param {Knitiv.Scope} $scope
	 * @param {angular.translate.ITranslateService} $translate
	 * @param {any} $copyToClipboard
	 * @param {angular.auto.IInjectorService} $injector
	 */
	constructor(
		$uibModal,
		$scope,
		$translate,
		$copyToClipboard,
		$injector,
	) {
		this.$scope = $scope;

		// ---

		this.form = undefined;

		/** @type {any} */
		this.parent = undefined;

		this.submission = undefined;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.previousKid = null;

		/** @type {?import('@knitiv/api-client-javascript').KNodeOptional} */
		this.kid = null;

		this.isLoading = true;

		/** @type {any} */
		this.table = null;

		this.isOpen = false;

		this.totalItems = 0;

		/** @type {any[]} */
		this.data = [];

		this.isReady = false;
		this.isLoaded = false;

		/** @type {number} */
		this.packet_index = 1;

		/** @type {number} */
		this.packet_size = packetSize;

		/** @type {number} */
		this.rowsCount = 0;

		this.$injector = $injector;

		const contextMenu = [
			{
				label: '<i class="fa fa-edit"></i> Editer la ligne',
				action: (/** @type {any} */ error, /** @type {any} */ cell) => this.edit(cell),
			}, {
				label: '<i class="fa fa-eye"></i> Détails de la ligne',
				action: (/** @type {any} */ error, /** @type {any} */ cell) => {
					const data = cell.getData();

					const { kid } = data;

					const modalInstance = $uibModal.open(rowDetailsModal({
						resolve: {
							kid: () => kid,
							locked: false,
						},
					}));

					const { result } = modalInstance;
					return result
						.then(() => true)
						.catch(error_ => {
							console.error('error', error_);
						});
				},
			},
			{
				label:  `<i class="fa fa-clipboard"></i> ${$translate.instant('mf.copy-kid')}`,
				action: (/** @type {any} */ error, /** @type {any} */ cell) => {
					const data = cell.getData();

					const { kid } = data;
					return $copyToClipboard(kid);
				},
			},
		];

		this.columns = [
			rowNumberColumnDefinition({
				width: 45,
			}),
			{
				title: 'Nom',
				field: 'name',
				formatter: (/** @type {any} */ cell) => {
					const data = cell.getData();

					const content = stringFormatter(data, null, null, this.$injector, false);

					return content;
				},
				cellDblClick: (/** @type {any} */ event, /** @type {any} */ cell) => {
					this.edit(cell);
				},
				contextMenu,
			},
			{
				title: 'Type',
				field: 'isa',
				formatter: (/** @type {any} */ cell) => {
					const data = cell.getData();
					const div = document.createElement('div');
					div.innerHTML = data.isa;
					return div;
				},
				cellDblClick: (/** @type {any} */ event, /** @type {any} */ cell) => {
					this.edit(cell);
				},
				contextMenu,
			},
		];

		this.options = {
			height:         350,
			layout:         'fitColumns',
			movableColumns: true,
			parent:         undefined,
			placeholder:    'Aucune donnée disponible',
			selectable:     'highlight',
		};
	}

	getTitle() {
		if (this.totalItems === 0) {
			return 'Aucun autre élément contenu';
		}
		if (this.totalItems === 1) {
			return `${this.totalItems} autre élément contenu`;
		}
		return `${this.totalItems} autres éléments contenus`;
	}

	/**
	 * @param {any} cell
	 */
	edit(cell) {
		const row = cell.getRow();
		const data = row.getData();
		if (this.parent) {
			this.parent.openForm(data.kid, _.cloneDeep(this.options.parent));
		}
	}

	async onReady() {
		if (this.isLoaded) {
			this.$scope.$evalAsync(() => {
				this.rowsCount = this.data.length;

				this.table.setColumns(this.columns);
				this.table.replaceData(this.data);
				this.isLoading = false;
			});
		}
	}

	/**
	 * @param {boolean} loadAll
	 */
	loadMore(loadAll) {
		if (loadAll === true) {
			this.packet_size = this.totalItems;
		}
		return this.fetchObject();
	}

	async fetchObject() {
		this.isLoading = true;

		if (!this.kid) {
			return;
		}

		if (this.packet_index === 0) {
			this.data = [];
			this.rowsCount = 0;
		}

		const objects = await APIV5.instance.objectToMe({
			node_kid:     this.kid,
			packet_size:  this.packet_size,
			packet_index: this.packet_index,
		}, { id: 'kelse.fetch-object' });

		this.$scope.$evalAsync(() => {
			for (const object of objects.nodes) {
				this.data.push({
					name: object.name,
					isa: object.isa_name,
					thumb_icon: object.thumb_icon,
					file: object.file,
					kid: object.kid,
				});
			}

			this.isLoaded = true;
			this.isLoading = false;

			if (this.packet_index <= 1) {
				this.totalItems = objects.nb ?? 0;
			}

			this.packet_index += objects.size;

			this.onReady();
		});
	}

	reload() {
		this.packet_index = 1;
		this.data = [];
		return this.fetchObject();
	}

	async fetch() {
		if (this.kid) {
			this.packet_index = 1;
			this.packet_size = packetSize; // this.options.packet_size ?? Defaults.query.packetSize;

			await this.fetchObject();
		}
	}

	/**
	 * @param {angular.IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (typeof changes?.kid?.currentValue === 'string') {
			(async () => this.fetch())();
		}
	}
}
